import uniqBy from 'lodash/uniqBy';
import filter from 'lodash/filter';




export function resolveHotkeyGroupByTemplateGroup(hotkeyGroup, templateGroup) {
  return resolveHotkeyByTemplate([], hotkeyGroup, [], templateGroup);
}




export function resolveHotkeyByTemplate(hotkeyItem = [], hotkeyGroup = [], templateItem = [], templateGroup = []) {
  // Order of array for uniq is important
  const items = uniqBy(templateItem.concat(hotkeyItem), uniqByKeyId);
  const groups = uniqBy(templateGroup.concat(hotkeyGroup), uniqByKeyId);

  return groups.concat(items);
}




export function getGroupFrom(array) {
  return filter(array || [], { is_group: true });
}




function uniqByKeyId(item) {
  return item.key || item.id;
}
